import fs from 'fs';
import matter from 'gray-matter';
import { serialize } from 'next-mdx-remote/serialize';
import path from 'path';
import { POSTS_PATH } from '../src/utils/mdxUtils';
import React from "react";
import AdvertisementLayout from "../src/layouts/AdvertisementLayout";
import AccessToken from "./api/accessToken";

type Props = {
  source: any;
  frontMatter: any;
};

export const config = { amp: 'hybrid' };

export default function Post({ source, frontMatter }: Props) {
  return (
      <AdvertisementLayout source={source} frontMatter={frontMatter} noIndex={false}/>
  );
}

export const getServerSideProps = async (context: any) => {
  const { req, res } = context;

  // Use the AccessToken logic to handle redirects
  // Ensure AccessToken is async or returns a promise
  const accessTokenResult = AccessToken(context);
  if (accessTokenResult && accessTokenResult.redirect) {
    const cookieValue = `redirect_done=yes; Path=/`;
    res.setHeader('Set-Cookie', cookieValue);
    return {
      redirect: accessTokenResult.redirect,
    };
  }

  const { params } = context;

  const postFilePath = path.join(POSTS_PATH, `${params.slug}.mdx`);
  if (!fs.existsSync(postFilePath)) {
    return {
      notFound: true, // Sayfa bulunamadı hatası
    };
  }
  const source = fs.readFileSync(postFilePath);
  const { content, data } = matter(source);

  const mdxSource = await serialize(content, {
    mdxOptions: {
      remarkPlugins: [],
      rehypePlugins: [],
    },
    scope: data,
  });

  return {
    props: {
      source: mdxSource,
      frontMatter: data,
    },
  };
};
